import { required, minLength, maxLength, numeric, email } from '@vuelidate/validators';
import { validDate, validDateOfBirth, validName } from '@core/services/custom-validators';
import moment from 'moment';

export default class ApplicationsPreFilledData {
	constructor(init) {
		this.language = null;
		this.firstName = null;
		this.lastName = null;
		this.dateOfBirth = null;
		this.phoneNumber = null;
		this.emailAddress = null;
		this.storeCode = null;

		if (init) {
			this.language = init.language;
			this.firstName = init.firstName;
			this.lastName = init.lastName;
			this.dateOfBirth = init.dateOfBirth ? moment(init.dateOfBirth, 'YYYY-MM-DDTHH:mm:ss.SSSSSSS[Z]').format('YYYY-MM-DDTHH:mm:ss.SSSSSSS[Z]') : init.dateOfBirth;
			this.phoneNumber = init.phoneNumber;
			this.emailAddress = init.emailAddress;
			this.storeCode = init.storeCode;
		}
	}

	getPropertyValue(propertyName) {
		return this[propertyName];
	}

	validation() {
		let data = {
			language: {},
			firstName: {},
			lastName: {},
			dateOfBirth: {},
			phoneNumber: {},
			emailAddress: {},
			storeCode: {},
		};

		data.firstName = {
			required,
			valid: validName,
		};
		data.lastName = {
			required,
			valid: validName,
		};
		data.dateOfBirth = {
			required,
			validDate,
			validDateOfBirth,
			minLength: minLength(10),
		};
		data.emailAddress = { required, email };
		data.phoneNumber = {
			required,
			numeric,
			minLength: minLength(10),
			maxLength: maxLength(10),
		};
		data.language = { required };

		return data;
	}
}
